import React from 'react';
import { DatePicker, Form } from 'antd';
import dayjs from 'dayjs';

const FunnelDatePicker = ({
  executing,
  executionParams,
  updateFunnelExecutionParameters,
}) => {
  return (
    <div>
      <Form name="funnel_report_date" layout="inline" disabled={executing}>
        <Form.Item
          name="date"
          label="Date Range"
          initialValue={
            executionParams
              ? [
                  dayjs(executionParams.startDate),
                  dayjs(executionParams.endDate),
                ]
              : [null, null]
          }
        >
          <DatePicker.RangePicker
            allowClear={false}
            showNow
            disabledDate={(date) =>
              date &&
              (date > dayjs().startOf('day') ||
                date < dayjs().subtract(90, 'day'))
            }
            onChange={(val) => {
              val &&
                updateFunnelExecutionParameters({
                  startDate: val[0].format('YYYY-MM-DD'),
                  endDate: val[1].format('YYYY-MM-DD'),
                });
            }}
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default FunnelDatePicker;
